"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useAnalytics = void 0;
var _react = require("react");
var _analyticsContext = require("../contexts/analyticsContext");
const useAnalytics = ()=>(0, _react.useContext)(_analyticsContext.analyticsContext);
exports.useAnalytics = useAnalytics;
